import React, {Component} from 'react';
import "./MainPage.css";
import Facade from "./Facade";
import Utils from "./Utils";
import ChangeResult from "./ChangeResult";
import CrmForm from "./CrmForm";
import IdentityOptions from "./IdentityOptions";
import QuickContact from "./QuickContact";
import FirstScreen from "./FirstScreen";
import BevStatHelper from "./BevStatHelper";
import MusicBtn from "./MusicBtn";

export default class MainPage extends Component
{


  constructor(props)
  {
    super(props);
    if ( props.fst )
    {
      Facade.model.firstScreenType= props.fst;
    }
    this.state = {
      role:-1,
      result:[]
    };
  }

  componentDidMount()
  {

    Facade.bevStatHelper.checkScroll();

  }


  componentWillUnmount()
  {
  }


  beginRole(role)
  {
    this.setState({role,result:null});
  }


  render()
  {
    return (
      <div  className="MainPage">

        <div className={"MenuBtn fst"+Facade.model.firstScreenType} onClick={QuickContact.show.bind(this)}>
          <img src={ require("./res/btn_QR.png") } alt=""/>
        </div>

        <FirstScreen />

        <div className="sectionYdbh" id="sectionYdbh">
          <div className="h1" >通往AGI，世界开启新章</div>
          <div className="h1" >未来已来！选择、行动！</div>
          <img className="titleImg" src={require("./res/variation.png")} alt=""/>
        </div>

        <div className="sectionRhgb" id="sectionRhgb">
          <div className="h1">如何改变，我能!</div>
          <div className="h3">Powered by 数字原力</div>
          <div className="rhgbRow">
            <div className="rhgbLi" >
              <img src={require("./res/change_boss.png")} alt=""/>
            </div>
            <div className="rhgbLi" >
              <img src={require("./res/change_term.png")} alt=""/>
            </div>
            <div className="rhgbLi" >
              <img src={require("./res/change_new.png")} alt=""/>
            </div>
            <div className="rhgbLi rhgbLiEnd" >
              <img src={require("./res/change_oneself.png")} alt=""/>
            </div>
          </div>
        </div>


        <div className="sectionChengJiu" id="sectionChengJiu">
          <div className="h1">iUXLabs带你从这里</div>
          <div className="h1">激活数字员工</div>
          <div className="h1">打造AI生产线</div>
          <div className="h1">登上数字航母</div>
          <div className="h1">革新组织 成就个人</div>
          <div className="chengJiuGrid">
            <img src={require("./res/feishu_chat.png")} alt=""/>
            <img src={require("./res/feishu_video.png")} alt=""/>
            <img src={require("./res/feishu_document.png")} alt=""/>
            <img src={require("./res/feishu_calendar.png")} alt=""/>
            <img src={require("./res/feishu_robot.png")} alt=""/>
            <img src={require("./res/feishu_OKR.png")} alt=""/>
            <img src={require("./res/feishu_serve.png")} alt=""/>
            <img src={require("./res/feishu_app.png")} alt=""/>
          </div>
          <div className="chengjiuDownload" id="sectionKaiqi">
            <div className="h2">开启碳基 & 硅基协同新时代</div>
            <a className="primaryBtn" href={Facade.GOTO_DOWNLOAD_URL}>立即注册</a>
          </div>
        </div>

        {/*表单*/}
        <CrmForm/>

        <div className="sectionAbout" id="sectionAbout">
          <div className="h1">上船！与我们同行</div>
          <div className="ourRow">
            <img src={require("./res/our_iuxlabs.png")} alt=""/>
            <img src={require("./res/our_feishu.png")} alt=""/>
          </div>

          <div className="h1">关于我们</div>
            <div className="aboutQrRow">
              {/*<div className="qrLi">*/}
              {/*  <img src={require("./res/QR_force.png")} alt=""/>*/}
              {/*  <span>微信号</span>*/}
              {/*</div>*/}
              <div className="qrLi">
                <img src={require("./res/qr_wx.png")} alt=""/>
                <span>视频号</span>
              </div>
              <div className="qrLi">
                <img src={require("./res/QR_ve.png")} alt=""/>
                <span>立即注册</span>
              </div>
            </div>
        </div>


        <div className="pageFooter">
          © iUX Labs 2020 备案号：沪ICP备14048341号-1
        </div>


        <QuickContact />

      </div>);
  }


}




